import { dateFormat } from '@/configs/dateFormat';
import dayjs, { Dayjs } from 'dayjs';

const formatNumber = (value: number, degit?: number): string => {
  return (
    (value &&
      value.toLocaleString(undefined, {
        minimumFractionDigits: degit ?? 0,
        maximumFractionDigits: 2,
      })) ||
    ''
  );
};

const formatDate = (
  date: string | Date | Dayjs,
  dateTimeFormat?: string,
): string => {
  return (
    (date && dayjs(date || undefined).format(dateTimeFormat || dateFormat)) ??
    ''
  );
};

export { formatNumber, formatDate };
